// -----------------  FETCH TV CATEGORIES -----------------
export const FETCH_SEARCH_QUERY_LOADING = 'FETCH_SEARCH_QUERY_LOADING';
export const FETCH_SEARCH_QUERY_SUCCESS = 'FETCH_SEARCH_QUERY_SUCCESS';
export const FETCH_SEARCH_QUERY_ERROR = 'FETCH_SEARCH_QUERY_ERROR';
